import { db } from '@/db/database'
import type { Setting } from '@/types'

export const settingsRepository = {
  async all(): Promise<Record<string, unknown>> {
    return Object.fromEntries((await db.settings.toArray()).map((item) => [item.key, item.value]))
  },

  async get<T>(key: string, fallback: T): Promise<T> {
    const item = await db.settings.get(key)
    return (item ? item.value : fallback) as T
  },

  async set<T>(key: string, value: T): Promise<void> {
    const setting: Setting = { key, value, updatedAt: new Date().toISOString() }
    await db.settings.put(setting)
  }
}
